export default {
  'base.captcha.clickToVerify': '点击进行验证',
  'base.captcha.verified': '验证成功',
  'base.captcha.title': '安全验证',
  'base.captcha.loading': '加载中...',
  'base.captcha.dragHint': '拖动滑块完成验证',
  'base.captcha.failCountdown': '验证失败，{countdown}秒后自动刷新',
  'base.captcha.refreshing': '正在刷新...',
  'base.captcha.refreshNow': '立即刷新',
  'base.avatarCrop.title': '裁剪头像',
  'base.avatarCrop.hint': '拖动调整位置，滚轮或滑块缩放',
  'base.avatarCrop.invalidImage': '请选择图片文件',
  'base.avatarCrop.tooLarge': '图片过大，请选择不超过 5MB 的文件',
  'base.avatarCrop.processFailed': '图片处理失败',
  'base.markdownEditor.uploadFailed': '图片上传失败',
}
